import React, { FC } from 'react';
// style
import './index.scss';

interface CalibrationRulerProps {
  width: number;
  className?: string;
}

// Calculates card height from the SVG aspect ratio so the full card stays visible.
const getCardHeight = (width: number): number => {
  if (window.innerWidth <= 1100) {
    // card_y.svg viewBox is 204 x 327.
    return width * (327 / 204);
  }
  return width * 0.62;
};

const CalibrationRuler: FC<CalibrationRulerProps> = ({ width, className }: CalibrationRulerProps) => (
  <div
    aria-label="Place Card Here"
    tabIndex={0}
    className={`calibration-ruler__wrapper ${className ?? ''}`}
    style={{ width: `${width}px` }}
  >
    <div className="calibration__arrows-container">
      <div className="arrow" />
      <div className="arrow reverse" />
    </div>
    <label htmlFor="Place Card Here">
      <div className="calibration-ruler" style={{ height: `${getCardHeight(width)}px` }} />
    </label>
  </div>
);

export default CalibrationRuler;
